<div class="user-picker">
    <div class="search-field">
        <input
            type="search"
            placeholder="Search..."
            [attr.data-uiid]="dataUiid + '-search'"
            [(ngModel)]="searchValue"
        />
        <mat-icon>search</mat-icon>
    </div>
    <div class="user-list" [attr.data-uiid]="dataUiid">
        @for (user of filterUsers(users); track $index) {
            @if ($index > 0) {
                <div class="user-item-divider">&nbsp;</div>
            }
            <div
                class="user-item"
                [class.selected]="currentList.users.includes(user.id)"
                [attr.data-uiid]="dataUiid + '-' + user.id"
                (click)="toggleUser(user)"
            >
                <user-avatar [user]="user"></user-avatar>
                <div class="user-item-details">
                    <span class="user-item-name" [class.deleted]="user.deleted"
                        >{{ user.firstName }} {{ user.lastName }}</span
                    >
                </div>
            </div>
        }
        @if (filterUsers(users).length === 0) {
            <div class="no-users">No users selected in {{ currentList.name }}</div>
        }
    </div>
</div>
